import BeforeEstimate from "./components/BeforeEstimate";
import ProjectEstimate from "./components/ProjectEstimate";
import EstimateSelect from "./components/EstimateSelect";
import {
  useResetSelectedProjectInfo,
  useSelectedProjectInfo,
  useSetSelectedOriginalInfo,
} from "./hooks/useTabStore";
import { useParams } from "react-router-dom";
import { Skeleton } from "@/components/ui/skeleton";
import { ItemSheetStatus } from "@/consts/Estimate";
import PendingEstimate from "./components/PendingEstimate";
import { useEffect, useMemo } from "react";
import { useFilteredOriginals } from "./hooks/useFilteredOriginals";
import {
  useSetIsEditing,
  useSetIsExcelDownloading,
} from "./hooks/useTableStore";

export default function ProjectEstimateScreen() {
  const { group_id = "" } = useParams();

  const selectedProjectInfo = useSelectedProjectInfo();
  const setSelectedOriginalInfo = useSetSelectedOriginalInfo();
  const resetSelectedOriginalInfo = useResetSelectedProjectInfo();

  const setIsEditing = useSetIsEditing();
  const setIsExcelDownloading = useSetIsExcelDownloading();

  const { allOriginals, isLoading, isError } = useFilteredOriginals(group_id);

  const selectedOriginal = useMemo(() => {
    if (!selectedProjectInfo) return null;
    return allOriginals.find(
      (item) =>
        item.project_id === selectedProjectInfo.projectId &&
        item.project_type === selectedProjectInfo.projectType
    );
  }, [selectedProjectInfo, allOriginals]);

  useEffect(() => {
    if (!selectedOriginal) return;

    // 공고가 있고, 산출내역서 생성을 한 경우
    if (!!selectedOriginal.status) {
      const isEqual = selectedProjectInfo?.originalId === selectedOriginal.id;
      if (!isEqual) {
        setSelectedOriginalInfo({ originalId: selectedOriginal.id });
      }
    }
  }, [allOriginals, selectedProjectInfo]);

  useEffect(() => {
    return () => {
      setIsEditing(false);
      setIsExcelDownloading(false);
      resetSelectedOriginalInfo();
    };
  }, []);

  if (isLoading) {
    return (
      <div className="mt-6">
        <Skeleton className="w-full h-96 bg-white" />
      </div>
    );
  }

  if (isError) {
    return null;
  }

  return (
    <div className="relative">
      <div className="mt-6">
        {!selectedProjectInfo || !selectedOriginal?.status ? (
          <BeforeEstimate />
        ) : selectedOriginal.status === ItemSheetStatus.COMPLETED ? (
          <ProjectEstimate selectedOriginal={selectedOriginal} />
        ) : (
          <PendingEstimate />
        )}
      </div>
      <EstimateSelect />
    </div>
  );
}
